<script setup lang="ts">
  import { ref, computed } from 'vue'
  import { useRouter, useRoute } from 'vue-router'
  import logoPhotoup from '@/assets/logo/photoup-3.webp'
  import logoRemovebg from '@/assets/logo/removebg-3.webp'

  const router = useRouter(),
    route = useRoute(),
    { VITE_APP_NAME, VITE_APP_VERSION } = import.meta.env,
    aiGroupLinks = {
      title: 'AI Product Photography',
      links: [
        {
          name: 'Auto Design',
          link: '/ai-create?mdx=0',
        },
        {
          name: 'By Reference',
          link: '/ai-create?mdx=1',
        },
        {
          name: 'Chat Create',
          link: '/ai-create?mdx=2',
        },
      ],
    },
    aboutGroupLinks = {
      title: 'About',
      links: [
        {
          name: 'Terms of Service',
          link: '/legal#terms',
        },
        {
          name: 'Privacy Policy',
          link: '/legal#privacy',
        },
        {
          name: 'Cookies Policy',
          link: '/legal#cookies',
        },
        {
          name: 'Chrome Extension',
          link: '/extension',
        },
        {
          name: 'Blog',
          link: 'https://photoup.ai/blog/'
        },
      ],
    }

  let imgLogo = computed(() => {
    let logo
    switch (VITE_APP_NAME) {
      case 'removebg.pro':
        logo = logoRemovebg
        break
      default:
        logo = logoPhotoup
        break
    }
    return logo
  })

  const onLink = (item) => {
    if (item.link.startsWith('/')) {
      router.push(item.link)
    } else {
      window.open(item.link)
    }
  }
</script>

<template>
  <footer class="footer">
    <div class="main">
      <img class="img-logo" :src="imgLogo" />
      <div class="introduction">
        {{ VITE_APP_NAME }} is the world’s first AI Agent specifically designed
        for product photo generation. {{ VITE_APP_NAME }} automatically
        transforms ordinary product photos into studio-quality product
        photography or mokcups, no manual prompting or editing required. It also
        can be used for AI background generation or AI fashion generation.
        <br />
        <br />
        {{ VITE_APP_NAME }} offers innovative, industry-first features such as
        Reference-Design product photo generation, which replicates the visual
        DNA of trending product photos. It is not only highly suitable for
        generating professional product photos for product listings on platforms
        like Amazon, Etsy, Shopify, or eBay, but also well-suited for creating
        high-quality product photos for social media and marketing.
      </div>
    </div>

    <div class="link-group-list">
      <div class="group-container" :key="aiGroupLinks.title">
        <span class="group-title">{{ aiGroupLinks.title }}</span>
        <div class="group-links">
          <div
            class="link"
            v-for="link in aiGroupLinks.links"
            :key="link.name"
            @click="onLink(link)"
          >
            {{ link.name }}
          </div>
        </div>
      </div>
    </div>

    <router-link to="/removebg" class="btn-removebg">
      Remove Background
    </router-link>

    <div class="link-group-list" style="left: 88vw">
      <div class="group-container" :key="aboutGroupLinks.title">
        <span class="group-title">{{ aboutGroupLinks.title }}</span>
        <div class="group-links">
          <div
            class="link"
            v-for="link in aboutGroupLinks.links"
            :key="link.name"
            @click="onLink(link)"
          >
            {{ link.name }}
          </div>
        </div>
      </div>
    </div>

    <div class="bottomer">
      <div class="copyright">
        <span
          >Copyright © 2025 {{ VITE_APP_NAME }} Ltd. All Rights Reserved.</span
        >
        <span class="version">Ver {{ VITE_APP_VERSION }}</span>
      </div>
      <div class="applogos">
        <a
          :href="
            VITE_APP_NAME == 'removebg.pro'
              ? 'https://x.com/zhangfreedom2'
              : ' https://x.com/hkaigctech'
          "
          target="_blank"
        >
          <img src="@/assets/icon/ic-twiter.png"
        /></a>
      </div>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
  .footer {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 3.2rem 2rem 8rem;
    box-sizing: border-box;
    background-color: #1f1f1f;
  }

  .main {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 40vw;

    .img-logo {
      height: 1.6rem;
      object-fit: contain;
    }

    .introduction {
      margin-top: 1rem;
      font-size: 1rem;
      line-height: 1.2rem;
      color: var(--color-text-secondary);
    }
  }

  .link-group-list {
    position: absolute;
    display: flex;
    flex-direction: row;
    left: 72vw;
    top: 3.2rem;

    .group-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      margin-right: 2vw;

      .group-title {
        font-size: 1.2rem;
        color: var(--color-text-placeholder);
        font-weight: 500;
      }

      .group-links {
        margin-top: 1rem;

        .link {
           margin-top: 0.4rem;
          font-size: 1rem;
          color: var(--color-text-secondary);
          text-decoration: underline;
          cursor: pointer;
        }

        @media (hover: hover) {
          .link:hover {
            color: var(--color-text-placeholder);
          }
        }
      }
    }
  }

  .btn-removebg {
    position: absolute;
    display: flex;
    flex-direction: row;
    left: 72vw;
    top: 15.6rem;
    font-size: 1.2rem;
    color: var(--color-text-placeholder);
    font-weight: 500;
    text-decoration: underline;
    cursor: pointer;
  }

  @media (hover: hover) {
    .btn-removebg:hover {
      color: var(--color-text-secondary);
    }
  }

  .bottomer {
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 4rem);
    margin-top: 2rem;
    bottom: 2rem;

    .copyright {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      font-size: 0.9rem;
      color: var(--color-text-secondary);

      .version {
        margin-left: 1vw;
      }
    }

    .applogos {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      font-size: 0;
      margin-right: 3vw;

      img {
        width: 2.4vw;
        height: 2.4vw;
        border-radius: 8px;
        opacity: 0.8;
        cursor: pointer;
        transition: opacity 0.3s ease, transform 0.3s ease;
      }

      @media (hover: hover) {
        img:hover {
          opacity: 1;
          transform: scale(1.1);
        }
      }
    }
  }

  @media (max-width: 768px) {
    .footer {
      flex-direction: column;
      padding: 2vw;
    }

    .main {
      width: 92vw;
      margin-top: 4vw;
    }

    .link-group-list {
      position: sticky;
      display: flex;
      flex-direction: column;
      width: 92vw;

      .group-container {
        margin-top: 4vw;

        .group-links {
          margin: 0;
          .link {
            float: left;
            margin-right: 4vw;
          }
        }
      }
    }

    .btn-removebg {
      position: static;
      left: 0;
      top: 0;
      width: 88vw;
      margin-top: 4vw;
    }

    .bottomer {
      position: static;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 96vw;

      .copyright {
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 0.8rem;
        color: var(--color-text-secondary);

        .version {
          margin-left: 0;
        }
      }

      .applogos {
        img {
          width: 8vw;
          height: 8vw;
          margin: 0;
        }
      }
    }
  }
</style>
